import React, { FC, isValidElement, ReactNode } from 'react'
import classNames from 'classnames'
import { isArray, isEmpty } from 'lodash'

import styles from './ButtonGroup.module.scss'

interface Props {
  children?: ReactNode
  alignment?: 'right' | 'left'
}

export const ButtonGroup: FC<Props> = ({ alignment = 'right', children }) => {
  const childrenToRender = (isArray(children) ? children : [children]).filter(item => isValidElement(item))
  const classList = classNames(styles.buttonGroup, {
    [styles.alignmentLeft]: alignment === 'left',
    [styles.alignmentRight]: alignment === 'right',
  })

  return (
    <div className={classList}>
      {!isEmpty(childrenToRender) &&
        childrenToRender.map((child, index) => (
          <div className={styles.buttonGroupItem} key={index}>
            {child}
          </div>
        ))}
    </div>
  )
}
